import { render, staticRenderFns } from "./PayerSourceRefs.vue?vue&type=template&id=a0b9f8c2&"
import script from "./PayerSourceRefs.vue?vue&type=script&lang=js&"
export * from "./PayerSourceRefs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports